<template>
  <!--弹框2 英文 开始-->
  <el-dialog :visible.sync="frameNoticeDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter-en">
    <div style="width:100%;text-align: center;">
      <div><img src="https://res.roompai.com/static/img/frame/notice.png" class="frame-big-img"></div>
      <div class="frame-text-hotel-sold wordBreak">
        {{$t('networkInterruptRetry')}}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-goback" @click="goFinalStep">{{$t('goFinalStep')}}</el-button>
    </span>
  </el-dialog>
  <!--弹框2 英文 结束-->
  <!--引入方式-->
  <!-- <frameNotice :frameNoticeDialog="frameNoticeDialog"></frameNotice> -->
</template>

<script>
import { getCityId } from '@/request/hotel.js'
export default {
  name: 'frameNotice',
  props: ['frameNoticeDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: ''
    }
  },
  created () {
    var query = this.common.linkQuerys
    if (JSON.stringify(query) !== '{}') {
      this.adult = parseInt(this.common.linkQuerys.adult)
      this.child = parseInt(this.common.linkQuerys.child)
      this.room = parseInt(this.common.linkQuerys.room)

      this.startdate = this.common.linkQuerys.start_date
      this.enddate = this.common.linkQuerys.end_date
    } else {
      var params = this.$route.params
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }
      if (JSON.stringify(params) !== '{}' || (searchData !== '{}' && searchData !== null)) {
        this.adult = parseInt(params.adult)
        this.child = parseInt(params.child)
        this.room = parseInt(params.room)
        this.startdate = params.start_date
        this.enddate = params.end_date
      }
    }

    // 获取城市ID
    this.getCityIdFun()
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    // 获取城市ID
    getCityIdFun: function () {
      var query = this.common.linkQuerys
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.common.linkQuerys.hotelid
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
      })
    },
    // 城市跳转
    goFinalStep: function () {
      var paysubmitInfo = {'click': 1}
      this.$emit('frameNoticeFun', paysubmitInfo)
    }
  }
}
</script>

<style scoped>
.textcenter-en{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{height:20px; font-size: 16px;color: #4F4C4C;text-align: center;}
.dialog-goback{width: auto;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;cursor:pointer;}
.dialog-goback:hover,.dialog-goback:focus{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }
.textcenter-en /deep/ .el-dialog{background: url(https://res.roompai.com/static/img/frame/sold-en.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 23%;}
@media screen and (max-width: 1000px) {
.dialog-goback{width:100%; margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/frameNotice.vue